import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { getFundsByKeys } from '../../../../utils/funds/funds-utility';
import { toLookup } from '../../../../utils/utils';

/**
 * @typedef {object} YearLimit
 * @property {string} type PURCHASE, EXCHANGE,etc.
 * @property {number} minimum
 * @property {number} maximum
 */

/**
 * @typedef {object} UserRegistration
 * @property {string} agreementType
 * @property {string} formattedEntityName
 * @property {string[]} modelAgreementUniqueIDs
 * @property {string} existingTickers
 * @property {string} classification
 * @property {YearLimit[]} currentYearLimit"
 * @property {YearLimit[]} priorYearLimitshouldValidate: f
/**
 *
 * @param state
 * @returns {UserRegistration}
 */
export const getSelectedRegistrationType = (state) =>
  state.userRegistrationTypeInfo.selectedRegistrationType;

export const getUserRegistrationTypeInfo = (state) =>
  state.userRegistrationTypeInfo;

export const getUserRegistrationTypeList = (state) =>
  state.userRegistrationTypeInfo.registrationTypes;

export const getRegistrationTypeInfoWithProductTypes = createSelector(
  (state) => state.userFunds.funds, // can't use simple selector as input due to circular import dependencies
  getUserRegistrationTypeInfo,
  (userFunds, userRegistrationTypeInfo) => {
    const userFundsArray = getFundsByKeys(userFunds);
    const userFundsByUniqueKey = toLookup(
      userFundsArray,
      (fund) => fund.uniqueKey
    );
    const { registrationTypes, selectedRegistrationType = [] } =
      userRegistrationTypeInfo;
    if (!Array.isArray(registrationTypes) || isEmpty(userFundsArray)) {
      return userRegistrationTypeInfo;
    }

    return {
      ...userRegistrationTypeInfo,
      selectedRegistrationType: {
        ...selectedRegistrationType,
        productType: isEmpty(selectedRegistrationType.modelAgreementUniqueIDs)
          ? ''
          : (
              userFundsByUniqueKey[
                selectedRegistrationType.modelAgreementUniqueIDs[0]
              ] || {}
            ).productType,
      },
      registrationTypes: registrationTypes,
    };
  }
);
